import {Component, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {JhiAlertService, JhiEventManager} from 'ng-jhipster';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {
  IPeriod,
  IStandardDateDetail,
  StandardDateDetail,
} from '@entities/tieu-chuan/tieu-chuan.model';
import {TieuChuanService} from '@entities/tieu-chuan/tieu-chuan.service';

@Component({
  selector: 'app-ngay-tuoi-duplicate-dialog',
  templateUrl: './ngay-tuoi-duplicate-dialog.component.html',
})
export class NgayTuoiDuplicateDialogComponent implements OnInit {
  isSaving: boolean;
  standardDate: IStandardDateDetail;
  listPeriodDropdown: IPeriod[];
  constructor(
    private dialogRef: MatDialogRef<NgayTuoiDuplicateDialogComponent>,
    private alertService: JhiAlertService,
    private eventManager: JhiEventManager,
    private titleService: Title,
    private tieuChuanService: TieuChuanService,
    private translate: TranslateService,
  ) {
    this.isSaving = false;
    this.standardDate = new StandardDateDetail();
  }

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant(
        'entities.tieu-chuan.ngay-tuoi-duplicate-dialog.Copy ngày tuổi_title',
      ),
    );
    this.getListPeriodDropdown();
  }

  getListPeriodDropdown() {
    this.tieuChuanService
      .queryPeriod({'tbGuidelineId.equals': this.standardDate.tbGuidelineId})
      .subscribe((res: any) => {
        this.listPeriodDropdown = res.body;
      });
  }
  save() {
    this.isSaving = true;
    this.tieuChuanService.duplicateGuidelineDetail(this.standardDate).subscribe(
      (response) => this.onSaveSuccess(),
      () => this.onSaveError(),
    );
  }

  private onSaveSuccess() {
    this.isSaving = false;
    this.eventManager.broadcast({
      name: 'tieuChuanDetailModification',
      content: 'standardDate',
    });
    this.dialogRef.close(true);
  }

  private onSaveError() {
    this.isSaving = false;
  }
}

@Component({
  selector: 'app-ngay-tuoi-duplicate-popup',
  template: '',
})
export class NgayTuoiDuplicatePopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<NgayTuoiDuplicateDialogComponent>;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.activatedRoute.data.subscribe(({ngaytuoi}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(NgayTuoiDuplicateDialogComponent, {
          disableClose: true,
          width: '380px',
        });
        this.dialogRef.componentInstance.standardDate = ngaytuoi;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('common.title.Chi tiết quy trình'),
    );
    this.dialogRef = null;
  }
}
